import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { BannerImage, BannerVideo } from '../components/banner-image'
import { ContentContainer } from '../components/content-container'
import { DecoratedFrame } from '../components/decorated-frame'
import { HeadBannar } from '../components/head-bannar'
import { AutoImage } from '../components/auto-image'
import { Section } from '../components/section'
import { SectionNavigator } from '../components/section-navigator'
import { SectionTextExtraLarge, SectionTextMedium, SectionTextSmall } from '../components/section-text'
import { SectionTitle } from '../components/section-title'
import { SectionImageOuter } from '../components/section-image-outer'
import SvgDiagram from '../generated/svg/diagram'
import { BlogSection } from '../components/blog-section'
import { SectionSpaceLarge, SectionSpaceMedium } from '../components/section-space'
import { Mbr } from '../components/br'
import { useBreakpoint } from '../hooks/use-breakpoint'
import SvgMobileDiagram from '../generated/svg/mobile-diagram'

const Outer = styled.div`
`

const NavigatorContainer = styled.div`
  margin-top: 4rem;
  align-self: center;
`

const DiagramOuter = styled(SectionImageOuter)`
  background-color: #fff;
  svg {
    display: block;
    width: 60rem;
    height: auto;
    max-width: 100%;
  }
`

type KitamiPageProps = {

}
export const KitamiPage: FunctionComponent<KitamiPageProps> = () => {
  const isMobile = useBreakpoint('40rem')
  return <Outer>
    <HeadBannar desktop={() => <BannerVideo src="/video.mp4" />} mobile={() => <BannerVideo src="/video_mobile.mp4" />}></HeadBannar>
    <ContentContainer>
      {/* <NavigatorContainer>
        <SectionNavigator labelMap={new Map([['about', 'About us'], ['diagram', '概念図']])} />
      </NavigatorContainer> */}
      <Section id="about">
        <SectionTitle>About us</SectionTitle>
        <SectionSpaceMedium />
        <DecoratedFrame leftBottom="/images/dec_01_01.png" rightTop="/images/dec_01_02">
          <AutoImage src="/images/img_01.jpg" mobileSrc="/images/img_01_mobile.jpg" />
        </DecoratedFrame>
        <SectionSpaceMedium />
        <SectionTextSmall>
          学校法人北見学園 認定こども園ムロノキッズでは<br />
          0歳から2歳までの保育を必要とする子どもが通う“プリスクール室の木”、<br />
          同じく0歳から2歳までの小規模保育所“キッズアミ”<br />
          そして、満3歳から5歳までの教育・保育を必要とする子どもが通う“室の木幼稚園”があり、<br />
          保育を必要とする子どもも、教育を必要とする子どもも一体で通える幼保連携型認定こども園です。<br />
          また、就園前に親子で通える未就園児プログラムや小学校入学後も定期的に通えるプログラムも用意し、<br />
          子育て支援の拠点として地域の子育て家庭に広く門戸が開かれた、開放的な総合幼児教育・保育施設です。
        </SectionTextSmall>
      </Section>
      <Section id="diagram">
        <DiagramOuter>
          {
            isMobile ?
            <SvgMobileDiagram />:
            <SvgDiagram />
          }
        </DiagramOuter>
      </Section>
      <BlogSection where={{categoryName: 'from'}}/>
    </ContentContainer>
  </Outer>
}